module.exports = __webpack_public_path__ + "img/jl.7c58220f.png";